import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useEventStore from '../../store/eventStore';
import StandsByCustomerPivotTable from '../../components/StandsByCustomerPivotTable';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

const EventChecklistPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { checklistData, fetchChecklistDataByEventId } = useEventStore();
  const { t } = useTranslation();

  useEffect(() => {
    if (id) fetchChecklistDataByEventId(id);
  }, [id, fetchChecklistDataByEventId]);

  if (!checklistData) {
    return <Spin>{t('events.loadingChecklistData')}</Spin>;
  }

  return (
    <StandsByCustomerPivotTable
      event={{ ...checklistData.event, items: (checklistData.event as any)?.items || [] }}
      customers={checklistData.customers}
    />
  );
};

export default EventChecklistPage;
